import common from "@/api/common.js";
export const shortMessageMixin = {
  data() {
    return {
      userGroupDataList: [],
      doctorGroupDataList: [],
    };
  },
  methods: {
    //自定义用户群数据列表
    getUserGroupDataList() {
      const loading = this.$loading();
      common
        .getUserGroupDataList()
        .then((res) => {
          let { data } = res;
          this.userGroupDataList = data.list.map((item) => {
            item.disabled = false;
            return item;
          });
          loading.close();
        })
        .catch((err) => oading.close());
    },
    //自定义医生群数据列表
    getDoctorGroupDataList() {
      const loading = this.$loading();
      common
        .getDoctorGroupDataList()
        .then((res) => {
          let { data } = res;
          this.doctorGroupDataList = data.list.map((item) => {
            item.disabled = false;
            return item;
          });
          loading.close();
        })
        .catch((err) => oading.close());
    },
  },
};
